/** DEV-260 — leitura dos campos numéricos. Texto que não é número segue como texto: o validador acusa. */
export function parseInteger(text: string): number | string | null {
  const t = text.trim();
  if (!t) return null;
  return /^-?\d+$/.test(t) ? Number(t) : t;
}

const MONEY = /^\d{1,3}(\.\d{3})*(,\d{1,2})?$|^\d+(,\d{1,2})?$/;

export function parseMoney(text: string): number | string | null {
  const t = text.replace(/^\s*R\$\s*/i, '').trim();
  if (!t) return null;
  if (!MONEY.test(t)) return t;
  return Number(t.replace(/\./g, '').replace(',', '.'));
}

export function formatMoney(value: number): string {
  return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
